import { useCallback, useEffect } from 'react'
import debounce from 'lodash/debounce'
import { getStorageKey, SAVED_DESIGN_ID_KEY } from '../store'

const DEBOUNCE_SAVE_DELAY_MS = 1000

/**
 * Source: https://www.synthace.com/autosave-with-react-hooks/
 *
 * @param data
 * @returns {null}
 * @constructor
 */
function AutoSave ({ data }) {

  const debouncedSave = useCallback(
    debounce(async (updatedState) => {
      const { config, ...savableState } = updatedState
      // console.log('saving data ....', savableState)

      localStorage.setItem(getStorageKey(sessionStorage.getItem(SAVED_DESIGN_ID_KEY)), JSON.stringify(savableState))

      //await saveExperimentDataToDb(newExperimentData);
    }, DEBOUNCE_SAVE_DELAY_MS),
    [],
  )

  // The magic useEffect hook. This runs only when `data.name` changes.
  // We could add more properties, should we want to listen for their changes.
  useEffect(() => {
    if (data) {
      debouncedSave(data)
    }
    // debouncedSave is wrapped in a useCallback with an empty dependency list,
    // thus it will not change and in turn will not re-trigger this effect.
  }, [ data, debouncedSave ])

  // Do not display anything on the screen.
  return null
}

export default AutoSave